import { useState, useEffect } from 'react'

export function useWindowSize() {
  // const [size, setSize] = useState({
  //   width:  typeof window !== 'undefined' ? window.innerWidth : 1200,
  //   height: typeof window !== 'undefined' ? window.innerHeight : 800,
  // })
// Fixed defaults keep prerendered HTML and first client render identical; the effect syncs the real size.
  const [size, setSize] = useState({ width: 1200, height: 800 })
  
  useEffect(() => {
    const handler = () => setSize({ width: window.innerWidth, height: window.innerHeight })
    window.addEventListener('resize', handler, { passive: true })
    handler()
    return () => window.removeEventListener('resize', handler)
  }, [])

  return {
    ...size,
    isMobile:  size.width < 576,
    isTablet:  size.width >= 576 && size.width < 992,
    isDesktop: size.width >= 992,
  }
}
